var map = {
	"./angbao-bonus-thaipusam.webp": 2496,
	"./angbao-bonus.webp": 2497,
	"./angbao-bonus_dewali.webp": 2498,
	"./cny-lucky-draw.webp": 2499,
	"./cny-promo.webp": 2500,
	"./dewali-promo.webp": 2501,
	"./fifa-logo.webp": 2502,
	"./fifa-prediction.webp": 2503,
	"./fifa-qna.webp": 2504,
	"./raya-promo.webp": 2505,
	"./welcome-cny-bonus.webp": 2506
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2495;